import { inject, InjectionToken } from '@angular/core';
import { ConfigService } from '@core/services';

export const API_BASE_URL: InjectionToken<string> = new InjectionToken<string>('API base url', {
  providedIn: 'root',
  factory: (): string => inject(ConfigService).apiUrl,
});
